/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import docApi from "api";
import { isInitialPageLoaded } from "selectors/pagedViewState";
import * as stores from "stores";

export const pageContentTypes = {
  NONE: 0,
  TEXT: 1,
  HYPERLINK: 2,
  UNKNOWN: 3,
  IMAGE: 4
};

export const pageContentTypesReverseMap = {
  "0": "NONE",
  "1": "TEXT",
  "2": "HYPERLINK",
  "3": "UNKNOWN",
  "4": "IMAGE"
};

export const getContentTypeUnderMouse = (pageIndex, xInPage, yInPage, pageZoomLevel, includeImages) =>
  docApi
    .getContentType(
      xInPage,
      yInPage,
      pageZoomLevel,
      pageIndex,
      includeImages,
      isInitialPageLoaded(stores) /* shouldDetectWeblinks */,
      isInitialPageLoaded(stores) /* shouldCreateContentPointMap */
    )
    .then(resp => resp.data.contentType)
    .catch(() => pageContentTypes.UNKNOWN);
